import React from 'react';
import { Link } from 'react-router-dom';

export default function Mission() {
  return (
    <section className="py-24 md:py-32 px-6" style={{ backgroundColor: '#f5f6ed' }}>
      <div className="max-w-4xl mx-auto">
        <span className="text-xs uppercase tracking-[0.3em] text-gray-500">
          Our Mission
        </span>
        <h2 className="text-4xl md:text-5xl font-light mt-4 mb-8 leading-tight">
          Mental health, treated with the rigor of a real science.
        </h2>
        <div className="w-20 h-px bg-gray-900 mb-10" />

        <p className="text-lg md:text-xl text-gray-700 leading-relaxed mb-10">
          Mental health is one of the largest unsolved problems of the modern world —
          poorly measured, weakly modeled, largely reactive. Cognitics exists to apply
          AI, machine learning, and data science to it at a foundational level: to
          move the field from intuition to measurement, and from measurement to
          intervention.
        </p>

        <Link to="/company" className="btn-ghost">
          Read more about Cognitics →
        </Link>
      </div>
    </section>
  );
}
